module.exports = __webpack_public_path__ + "img/creative.2de303d5.png";